import { HeartOutlined, HomeOutlined, SearchOutlined } from '@ant-design/icons'
import { Icon } from '@/components/atoms/Icon'
import { useNavigate } from 'react-router-dom'
import { CustomLink } from '@/components/atoms/CustomLink'
import { ValidateIcon } from '../ValidateIcon'
import { useTranslation } from 'react-i18next'
import './footer.scss'

export const Footer = ({ isGuest }: { isGuest: boolean }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const goHome = () => {
    navigate('/home')
  }

  const links = [
    {
      name: t('footer.home'),
      icon: <HomeOutlined />,
      to: '/home'
    },
    {
      name: t('footer.search'),
      icon: <SearchOutlined />,
      to: '/search'
    },
    {
      name: t('footer.favorites'),
      icon: <HeartOutlined />,
      to: '/favorites'
    }
  ]

  return (
    <footer className='m-footer'>
      <header className='m-footer__header' onClick={() => goHome()}>
        <ValidateIcon isGuest={isGuest} />
        <h1 className='m-footer__header-spotify'>
          {isGuest ? 'Deezer' : 'Spotify'}
        </h1>
      </header>
      <ul className='m-footer__container'>
        {links.map((link, index) => (
          <CustomLink key={index} to={link.to}>
            <Icon>
              {link.icon}
              <span className='m-footer__title'>{link.name}</span>
            </Icon>
          </CustomLink>
        ))}
      </ul>
    </footer>
  )
}
